"use client"

import { useRouter, useSearchParams } from "next/navigation"
import { useState } from "react"

import { buildRoute } from "@lib/routes"
import { clearLastCheckoutProduct, LastCheckoutProduct } from "@lib/util/checkout-cookie"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { Button as NeloButton } from "@modules/common/components/nelo-button"
import Thumbnail from "@modules/products/components/thumbnail"

import InstallmentPrice from "./installment-price"

type LastCheckoutProductProps = {
  product: LastCheckoutProduct
}

const LastCheckoutProductView = ({ product }: LastCheckoutProductProps) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const customerExternalId = searchParams.get("customerExternalId")
  const [isLoading, setIsLoading] = useState(false)

  const handleWebCheckoutLoading = () => {
    setIsLoading(true)
    setTimeout(() => {
      setIsLoading(false)
    }, 5000)
  }

  const handleOnClick = () => {
    if (!product) return
    handleWebCheckoutLoading()
    router.push(`?signup=1&productId=${product.id}&variantId=${product.variantId}`)
  }

  if (!product) return null

  return (
    <>
      <div className="grid max-h-[402px] grid-cols-1 gap-y-8 overflow-hidden p-px px-4 pb-4">
        <div className="grid w-full grid-cols-[80px_minmax(0,1fr)_95px] gap-x-4">
          <LocalizedClientLink href={buildRoute.product(product.handle)} className="w-20">
            <div className="overflow-hidden rounded-md border border-gray-200">
              <Thumbnail thumbnail={product.thumbnail} size="square" className="rounded-none" />
            </div>
          </LocalizedClientLink>
          <div className="flex flex-col justify-start overflow-hidden">
            <h3 className="text-base-regular line-clamp-2 overflow-hidden text-ellipsis break-words">
              <LocalizedClientLink href={buildRoute.product(product.handle)}>{product.title}</LocalizedClientLink>
            </h3>
            {product.variantLabel && <span className="text-small-regular text-ui-fg-subtle">{product.variantLabel}</span>}
          </div>
          <div className="flex w-full flex-col items-end justify-between">
            <span className="text-base-regular font-medium">{product.price}</span>
            <button onClick={clearLastCheckoutProduct} className="text-small-regular mt-auto text-ui-fg-interactive">
              Eliminar
            </button>
          </div>
        </div>
      </div>
      <div className="px-4">
        <InstallmentPrice finalPrice={product.price} customerExternalId={customerExternalId ?? undefined} />
      </div>
      <div className="text-small-regular flex flex-col gap-y-4 p-4">
        <NeloButton onClick={handleOnClick} className="w-full" loading={isLoading}>
          Continuar al checkout
        </NeloButton>
      </div>
    </>
  )
}

export default LastCheckoutProductView
